export interface IGridListingFilterValue {
    name: string;
    value: string | number | boolean | Array<string> | Array<number> | Array<boolean>;
}

export interface IGridListingFilterDescription {
    titles: string[];
    quick?: boolean;
    name?: string;
    noBottom?: boolean;
    count?: number;
    clearSelection?: boolean;
    banClearSelection?: boolean;
}

export interface IGridListingFilter {
    name(): string;
    values(): IGridListingFilterValue[];
    descriptions(): (value: any) => IGridListingFilterDescription;
    setQuick(quick?: boolean): void;
    setNoBottom(noBottom?: boolean): void;
    disableAutoClearSelection(strict?: boolean): void;
    isEmpty(): boolean;
    clear(): void;
    ready(): Promise<void>;
    getClearSelection(): boolean;
    detach(): void;
    setBanClearSelection(val?: boolean): void;
    getStrictClearSelection(): boolean;
}

export abstract class AbstractGridListingFilter implements IGridListingFilter {
    protected quick = false;
    protected noBottom = false;
    protected clearSelection = true;
    protected banClearSelection = false;
    protected strictClearSelection = false;

    constructor(
        protected _name: string,
        protected scopeVariable: any
    ) {}

    public abstract values();

    public abstract isEmpty(): boolean;

    public abstract descriptions();

    public abstract clear(): void;

    public setQuick(quick = false) {
        this.quick = quick;
    }

    public setBanClearSelection(val?: boolean) {
        if (val !== undefined && val !== null) {
            this.banClearSelection = val;
        } else {
            this.banClearSelection = !this.getClearSelection() && !this.isEmpty();
        }
    }

    public getBanClearSelection() {
        return this.banClearSelection;
    }

    public disableAutoClearSelection(strict?: boolean) {
        this.clearSelection = false;
        if (strict) {
            this.strictClearSelection = true;
            this.setBanClearSelection();
        }
    }

    public getStrictClearSelection() {
        return this.strictClearSelection;
    }

    public setNoBottom(noBottom = false) {
        this.noBottom = noBottom;
    }

    public getClearSelection() {
        return this.clearSelection;
    }

    public name() {
        return this._name;
    }

    public ready() {
        return Promise.resolve();
    }

    protected objToValues(obj): IGridListingFilterValue[] {
        const values = [];
        for (const k in obj)
            if (Object.prototype.hasOwnProperty.call(obj, k)) {
                values.push({
                    name: k,
                    value: obj[k]
                });
            }
        return values;
    }

    public detach(): void {
        //		delete this.scopeVariable;
        // remove reference to the scoped variable and avoid scopeVariable.value runtime errors
        this.scopeVariable = {};
    }
}

export class GridListingFilter extends AbstractGridListingFilter {
    public values() {
        return [
            {
                name: this.fieldName(this.scopeVariable),
                value: this.value(this.scopeVariable)
            }
        ];
    }

    public fieldName(variable: IGridListingFilterValue) {
        return variable.name;
    }

    public value(variable) {
        return variable.value;
    }

    public title(name: string, value) {
        return `${name}: ${value}`;
    }

    public descriptions() {
        return (values: IGridListingFilterValue[]) => {
            const titles = values.map(value => {
                return this.title(value.name, value.value);
            });

            return {
                quick: this.quick,
                empty: this.noBottom,
                titles: titles
            };
        };
    }

    public isEmpty() {
        const value = this.value(this.scopeVariable);
        return !value || value === 'Unknown' || (Array.isArray(value) && value.length === 0);
    }

    public clear() {
        this.scopeVariable.value = '';
    }

    public static TMaxQuickSetup(filterName: string, fieldName: string, scopeVariable: any): GridListingFilter {
        scopeVariable.name = fieldName;
        return new GridListingFilter(filterName, scopeVariable);
    }
}
